import { render, staticRenderFns } from "./Promocoes.vue?vue&type=template&id=77208355"
import script from "./Promocoes.vue?vue&type=script&lang=ts"
export * from "./Promocoes.vue?vue&type=script&lang=ts"
import style0 from "./Promocoes.vue?vue&type=style&index=0&id=77208355&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports